import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Action bar for a drawer. Place it last in the `app-drawer-layout` body, inside the
 * form that owns the submit button if there is one (that form, and any component host
 * between it and the body, needs `flex flex-1 flex-col`). It sits at the bottom of the
 * drawer when the content is short and sticks to the bottom of the scroll area when it
 * is long; the negative margins and offset span the body's 24px padding.
 */
@Component({
  selector: 'app-drawer-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // The transparent top padding keeps a 24px gap above the bar without blocking clicks on
  // content that scrolls beneath it.
  host: { class: 'pointer-events-none sticky -bottom-6 z-10 -mx-6 -mb-6 mt-auto block shrink-0 pt-6' },
  template: `
    <div
      class="pointer-events-auto flex items-center gap-2 border-t border-border-muted bg-surface-elevated px-6 py-4"
    >
      <ng-content />
    </div>
  `,
})
export class DrawerFooterComponent {}
